/**
 * SiteMapRoute: the `advanced=true` soft flag gate for the site map.
 *
 * Without the flag it renders the fallback (Not Found) and nothing else, so no site map
 * data is requested and the map library is never loaded. Removing the flag later means
 * routing straight to SiteMapPage.
 */
import type { ReactNode } from 'react';
import { useAdvancedMode } from '../../hooks/useAdvancedMode';
import { SiteMapPage } from './SiteMapPage';

interface SiteMapRouteProps {
  readonly fallback: ReactNode;
}

export function SiteMapRoute({ fallback }: SiteMapRouteProps): JSX.Element {
  const { isAdvancedMode } = useAdvancedMode();
  return isAdvancedMode ? <SiteMapPage /> : <>{fallback}</>;
}
